// const l = window.localStorage;
const s = window.sessionStorage

export const sess = {
  removeItem: (item) => s.removeItem(item),
  isSet: (item) => item !== undefined,
}

export const local = {}
const storage = {
  sess,
  local,
}

export default storage
